import React, { ErrorInfo } from "react";
import { Button, Result } from "antd";
import { ReloadOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { withRouter } from "./ErrorBounderyWrapper";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  router: {
    navigate: (to: string | number) => void;
  };
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundaryBase extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  handleGoBack = () => {
    this.props.router.navigate("/"); // Equivalent to history.goBack()
    window.location.reload();
  };

  render() {
    const { hasError, error } = this.state;
    if (hasError) {
      return (
        <Result
          status="500"
          title="Something went wrong"
          subTitle={error?.message || "An unexpected error occurred."}
          extra={
            <>
              <Button type="primary" icon={<ReloadOutlined />} onClick={this.handleReload} style={{ marginRight: 8 }}>
                Reload Page
              </Button>
              <Button icon={<ArrowLeftOutlined />} onClick={this.handleGoBack}>
                Go Back
              </Button>
            </>
          }
        />
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withRouter(ErrorBoundaryBase);
